<template>
  <PagesProgramComponent
    :pageData="data"
    :childData="childData"
    :pastChildData="pastChildData"
    :paginateChildData="paginateChildData"
    :paginatePastChildData="paginatePastChildData"
  />

  <NuxtPage />
</template>

<script setup>
// 1
defineI18nRoute({
  paths: {
    en: '/programme',
    nl: '/programma'
  }
})

// 1
const queryPath = queryProgramsPage(baseStrapiGetSlugQueryObjectFromRoute())
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPath } }
  )
})

if (!data?.value?.data?.id || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)

// 2
const queryCurrentChildDataObject = {
  ...baseRouteGetPublicationStateQuery(),
  filters: {
    $or: [
      { date_time_start: { $gte: dayJs().format('YYYY-MM-DD') }},
      { date_time_end: { $gte: dayJs().format('YYYY-MM-DD') }}
    ]
  },
  sort: ['date_time_start:asc', 'date_time_end:asc']
}

const { data: childData, error: childError } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryProgramEntryThumbnails(queryCurrentChildDataObject) } }
  )
})

const paginateChildData = async () => {
  const { data: nextData, error: nextError } = await useAsyncData(() => {
    return $fetch('/api/strapi-rest',
    { query: { path: queryProgramEntryThumbnails({ ...queryCurrentChildDataObject, page: childData?.value?.meta?.pagination?.page + 1 }) } }
    )
  })
  if (nextData?.value) {
    childData.value.data = childData.value.data.concat(nextData.value.data)
    childData.value.meta = nextData.value.meta
  }
}

// 3
const queryPastChildDataObject = {
  ...baseRouteGetPublicationStateQuery(),
  filters: {
    $and: [
      { date_time_start: { $lt: dayJs().format('YYYY-MM-DD') } },
      { date_time_end: { $lt: dayJs().format('YYYY-MM-DD') } }
    ]
  },
  sort: ['date_time_start:desc', 'date_time_end:asc']
}

const { data: pastChildData, error: pastChildError } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryProgramEntryThumbnails(queryPastChildDataObject) } }
  )
})

const paginatePastChildData = async () => {
  const { data: nextData, error: nextError } = await useAsyncData(() => {
    return $fetch('/api/strapi-rest',
      { query: { path: queryProgramEntryThumbnails({ ...queryPastChildDataObject, page: pastChildData?.value?.meta?.pagination?.page + 1 }) } }
    )
  })

  if (nextData?.value) {
    pastChildData.value.data = pastChildData.value.data.concat(nextData.value.data)
    pastChildData.value.meta = nextData.value.meta
  }
}
</script>
